import React, { useEffect } from "react";
import Routes from "./Routes";
import { useHistory } from "react-router";
import "../src/assets/styles/index.css";
import { BASE_URL } from "./Helpers";

const App = () => {
  const history = useHistory();

  // Limpia el contenido estático al montar
  useEffect(() => {
    const staticContent = document.getElementById("estatic-home");
    if (staticContent) staticContent.innerHTML = "";
  }, []);

  // Asegura que el rol esté en localStorage
  useEffect(() => {
    const role = window.localStorage.getItem("role");
    if (!role) {
      window.localStorage.setItem("role", JSON.stringify({ role: "user" }));
    }
  }, []);

  // Inyecta script de Google AdSense solo una vez
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2169328241628830";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  // Solo para debug, puedes quitarlo en producción
  useEffect(() => {
    console.log("BASE_URL:", BASE_URL);
  }, []);

  return (
    <>
      {/* Si necesitas el botón atrás, descomenta la siguiente línea */}
      {/* <BackButton /> */}
      <Routes />
    </>
  );
};

export default App;
